import { createTheme, ThemeOptions, PaletteOptions } from '@mui/material';
import { createComponents } from './createComponents';
import { baseTheme } from './baseTheme';
import { darkPalette } from './darkPalette';
import { lightPalette } from './lightPalette';

interface ExtendedPalette extends PaletteOptions {
  error?: PaletteOptions['error'] & {
    hoverBg: string;
    hoverBorder: string;
  };
}

export interface ExtendedTheme extends ThemeOptions {
  palette?: ExtendedPalette;
}

export const darkTheme = createComponents(
  createTheme(baseTheme(darkPalette), darkPalette)
);

export const lightTheme = createComponents(
  createTheme(baseTheme(lightPalette), lightPalette)
);
